export default "__VITE_ASSET__BQrO_1nW__"